import React from 'react';

/**
 * Full-viewport loading state for the App.js auth gate (profile + subscription
 * still resolving). Presentation only — the gate logic stays in App.js.
 *
 * The bloom is decorative (aria-hidden); the text is the announced status.
 * Base styles are the calm resting state — under prefers-reduced-motion the
 * animations are removed and this renders as a static soft bloom.
 */
const AppLoading = () => (
  <div
    role="status"
    aria-live="polite"
    className="h-screen-dvh flex flex-col items-center justify-center gap-7 bg-background px-6 text-center"
  >
    <div className="app-loading-bloom" aria-hidden="true">
      <span className="app-loading-halo" />
      <span className="app-loading-core" />
    </div>
    <p className="text-base text-text-secondary">Et lite øyeblikk&nbsp;…</p>
  </div>
);

export default AppLoading;
